import BaseService from "@/shared/base.service";

export interface DataSourceSchema {
  connector_in_id: string;
  data_source_id: number;
  data_source_name: string;
  data_source_type: string;
  schema: Array<{
    name: string;
    columns: string[];
  }>;
}

export class DataSourceSchemaService {
  static async GetSchema(
    connector_in_id: string,
    refresh = true
  ): Promise<DataSourceSchema | null> {
    try {
      const params = {
        connector_in_id,
        refresh: refresh ? "true" : "false",
      };

      const queryParams = Object.fromEntries(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(params).filter(([_, v]) => v != null)
      );

      const response = await BaseService.get<DataSourceSchema>(
        `queries/schema`,
        queryParams
      );

      return response ?? null;
    } catch (error) {
      console.error("Error in GetSchema:", error);
      return null;
    }
  }
}
